<div *ngIf="isLoading">Loading Title List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="title" [(ngModel)]="model.title" [required]="required">
  <option *ngFor="let singleTitle of titles" [ngValue]="singleTitle">{{ singleTitle.name }}</option>
</select>
